import React from "react";
import { closeMobileNav, useMetisMenu } from "./navMenu";

const GROUPS = [
  {
    title: "Reports",
    icon: "flaticon-381-notepad",
    links: [
      ["/rider-settlement", "Rider Salary"],
      ["/deliveryboy-reports", "Rider Collection"],
      ["/restaurant-settlement", "Restaurant Settlement"],
      ["/payouts", "Restaurant Payouts"],
      ["/reports", "Orders Report"],
    ],
  },
  {
    title: "Users",
    icon: "flaticon-381-user",
    links: [["/delivery-boys", "Delivery Boys"]],
  },
];

export default function AccountantNavBar() {
  useMetisMenu();
  return (
    <div>
      <div className="deznav-backdrop" onClick={closeMobileNav} />
      <div className="deznav">
        <div className="deznav-scroll">
          <ul className="metismenu" id="menu">
            {GROUPS.map((group) => (
              <li key={group.title} className="marginToClass">
                <a className="has-arrow ai-icon" href="#menu" aria-expanded="false" onClick={(e) => e.preventDefault()}>
                  <i className={group.icon} />
                  <span className="nav-text">{group.title}</span>
                </a>
                <ul aria-expanded="false" className="mm-collapse">
                  {group.links.map(([href, label]) => (
                    <li key={href}>
                      <a href={href} onClick={closeMobileNav}>
                        {label}
                      </a>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
